import { MutationOptions, useMutation } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';

export interface ClaimPointResponse {
  claimed_points: number;
  tier: string;
  total_points: number;
}

export const claimScore = async () => {
  const response = await apiClient.post<ClaimPointResponse>(`v2/users/scores/claims`);
  return response.data;
};

export type useClaimPointOptions<TError = Error, TContext = unknown> = MutationOptions<
  ClaimPointResponse,
  TError,
  TContext
>;

export const useClaimScore = <TError = Error>(
  options?: useClaimPointOptions<TError, void>,
) => {
  return useMutation({
    mutationFn: claimScore,
    ...options,
  });
};
